import React from 'react';
import { usePanel } from 'contexts/panelContext';
import PersonalDetails from './PersonalDetails';

export const MyPersonalDetails = () => {
	const { currentApplicationData } = usePanel();
	return <PersonalDetails applicationData={currentApplicationData} isYour />;
};
